import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { UiButton } from 'src/components/UI/Button';
import { UiHoverTooltip } from 'src/components/UI/HoverTooltip';
import { dispatchAnyRequestStart } from 'src/store/anyRequest/helpers';
import { apiContinueWithTrial } from 'src/api/plusSubscriptionPlanSelection';
import { useAnyRequest } from 'src/utils/hooks/useAnyRequest';
import { PlusSubscriptionContinueWithTrialPlanResponseType } from 'src/models/plusSubscription';
import { GoogleTagManager } from 'src/utils/GoogleTagManager';
import { hardRedirect } from 'src/utils/hardRedirect';
import { ROUTE_START_GUIDE_PLUS_SUBSCRIPTION } from 'src/routes';
import { useNsTHelper } from 'src/utils/i18n';
import { PlusSubscriptionIsAvailableSelector } from 'src/store/plusSubscription/selectors';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import styles from 'src/styles/common/plusSubscription/modal/buttons.module.scss';

export const PlusSubscriptionButtonsFreeTrial: FC = () => {
  const tHelper = useNsTHelper('plusSubscription', 'modals.common.buttons');

  const { Name } = useSelector(deCommonCurrentPartnerSelector);
  const isDisabled = !useSelector(PlusSubscriptionIsAvailableSelector);

  const uniqueId = 'continueWithTrial';

  const continueWithTrial = useCallback(() => {
    dispatchAnyRequestStart({
      data: null,
      apiFunction: apiContinueWithTrial,
      uniqueId,
    });
  }, []);

  const response = useAnyRequest<PlusSubscriptionContinueWithTrialPlanResponseType>(uniqueId, {
    onSuccess: (response) => {
      if (response.PlusSubscriptionEventModel) {
        const e = response.PlusSubscriptionEventModel;

        GoogleTagManager.pushEvent({
          event: e.EventName,
          customer_type: e.CustomerType,
          billing: e.Billing,
          plan: e.Plan,
          total: e.Total,
          email: e.Email,
        });
      }

      hardRedirect(ROUTE_START_GUIDE_PLUS_SUBSCRIPTION);
    },
  });

  return (
    <UiHoverTooltip text={tHelper('disabledTooltip', { partner: Name })} render={isDisabled} className={styles.tooltip}>
      <UiButton className={styles.button} onClick={continueWithTrial} disabled={isDisabled} loading={response.loading}>
        {tHelper('tryForFree')}
      </UiButton>
    </UiHoverTooltip>
  );
};
